

















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import { Observer } from "mobx-vue";

@Observer
@Component({
  components: {
    ValidationObserver
  }
})
class SubmitForm extends Vue {
  @Prop() submitRequest?: Function;
  @Prop({ default: false }) loading?: boolean;
  @Prop({ default: "" }) dataCy?: string;

  async handleSumbitRequest(handleSubmit: (cb: Function) => void, reset: () => void, validate: () => Promise<boolean>) {
    if (await validate()) {
      // Provide a minimal fallback function to avoid empty arrow function lint error
      handleSubmit(this.submitRequest ?? (() => undefined));
      reset();
    }
  }
}

export default SubmitForm;
